import { render } from "./OpenPosition.vue?vue&type=template&id=65970f2a&scoped=true&ts=true"
import script from "./OpenPosition.vue?vue&type=script&lang=ts"
export * from "./OpenPosition.vue?vue&type=script&lang=ts"

import "./OpenPosition.vue?vue&type=style&index=0&id=65970f2a&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65970f2a"]])

export default __exports__